import { MdSend } from "react-icons/md";
import { useState } from "react";

export default function ChatInput({ disabled, onSend }) {
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {  // Ensure it's not empty
      onSend(message);  // Send the message
      setMessage("");  // Clear the input
    }
  };

  return (
    <form 
      className="border-2 border-slate-400 rounded-lg p-2 flex flex-row m-2 text-slate-50"
      onSubmit={handleSubmit}  // Use the handleSubmit function
      autoComplete="off"
    >
      <input
        name="message"
        placeholder="Type your message here..."
        className="w-full bg-slate-700 text-slate-50 focus:outline-none"
        value={message}
        onChange={(e) => setMessage(e.target.value)}  // Update message state
      />
      <button
        disabled={disabled || !message.trim()}  // Disable if input is empty or disabled
        className="bg-slate-500 text-white font-bold py-2 px-4 rounded hover:bg-pink-400 disabled:bg-slate-600 disabled:text-slate-400"
      >
        <MdSend />
      </button>
    </form>
  );
}
